import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { useEventListener } from "pages/Hooks/useEventListener";
import { TRIGGER_DIALOG } from "pages/constants/EventKeys";

export default function AlertDialog() {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const handleClose = () => setOpen(false);

  type ModalContent = {
    type: string;
    typeParams?: Record<string, string>;
    actions?: Array<{
      label: string;
      variant?: string;
      color?: string;
      action?: Function;
    }>;
  };

  const [content, setContent] = React.useState<ModalContent>(
    {} as ModalContent
  );

  useEventListener(TRIGGER_DIALOG, (content: ModalContent) => {
    setContent(content);
    setOpen(true);
  });
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t(`FEEDBACK.DIALOG.${content.type}.title`, content.typeParams ?? {})}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t(`FEEDBACK.DIALOG.${content.type}.text`, content.typeParams ?? {})}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {content.actions &&
          content.actions.map((action: any, i: number) => (
            <Button
              key={i}
              variant={action.variant || "outlined"}
              color={action.color || "success"}
              onClick={(e: any) => {
                if (action.action) {
                  action.action(e);
                }
                handleClose();
              }}
            >
              {t(`FORM.SUBMIT.${action.label}`)}
            </Button>
          ))}
      </DialogActions>
    </Dialog>
  );
}
